import {
  type BrewKey,
  type Product,
  type RoastKey,
  type TasteProfileKey,
  tasteProfile,
} from '@c214/shared';
import { useMemo, useState } from 'react';

export interface Filters {
  roast: RoastKey | 'all';
  profile: TasteProfileKey | 'all';
  brew: BrewKey | 'all';
  region: string | 'all';
}

const INITIAL: Filters = { roast: 'all', profile: 'all', brew: 'all', region: 'all' };

export function useProductFilters(products: Product[]) {
  const [filters, setFilters] = useState<Filters>(INITIAL);

  const setFilter = <K extends keyof Filters>(key: K, value: Filters[K]) =>
    setFilters((current) => ({ ...current, [key]: value }));

  const regions = useMemo(
    () => [...new Set(products.map((product) => product.region))].sort(),
    [products],
  );

  const filtered = useMemo(
    () =>
      products.filter((product) => {
        if (filters.roast !== 'all' && product.roast !== filters.roast) return false;
        if (filters.brew !== 'all' && !product.brew.includes(filters.brew)) return false;
        if (filters.region !== 'all' && product.region !== filters.region) return false;
        if (filters.profile !== 'all' && tasteProfile(product) !== filters.profile) return false;
        return true;
      }),
    [products, filters],
  );

  return { filters, setFilter, filtered, regions };
}
